import React from 'react';
import { motion } from 'framer-motion';
import { Clock, Info, ArrowRight, Download } from 'lucide-react';
import { Link } from 'react-router-dom';
import { dining as outlets } from '../data/dining';
export function Dining() {
  return <div className="w-full bg-club-canvas" data-id="element-718">
      {/* Page Banner */}
      <section className="relative h-[50vh] min-h-[400px] flex items-center justify-center overflow-hidden" data-id="element-719">
        <div className="absolute inset-0 z-0" data-id="element-720">
          <img src="https://images.unsplash.com/photo-1414235077428-338989a2e8c0?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80" alt="Fine Dining" className="w-full h-full object-cover" data-id="element-721" />
          <div className="absolute inset-0 bg-club-navy/50 mix-blend-multiply" data-id="element-722"></div>
        </div>
        <div className="relative z-10 text-center px-4 mt-16" data-id="element-723">
          <motion.span className="eyebrow text-club-gold mb-4 block" initial={{
          opacity: 0,
          y: 10
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} data-id="element-724">
            Culinary Excellence
          </motion.span>
          <motion.h1 className="text-5xl md:text-6xl font-serif text-white mb-6" initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.2,
          duration: 0.6
        }} data-id="element-725">
            Dining & Bars
          </motion.h1>
        </div>
      </section>

      {/* Intro */}
      <section className="py-20 px-4 max-w-4xl mx-auto text-center" data-id="element-726">
        <p className="text-xl text-club-ink/80 font-light leading-relaxed mb-8" data-id="element-727">
          From exquisite fine dining to relaxed casual fare, Andhra Social &
          Cultural Association offers a diverse array of culinary experiences.
          Our executive chef and sommelier work in tandem to curate seasonal
          menus and wine pairings that delight the most discerning palates.
        </p>
        <div className="flex justify-center gap-4" data-id="element-728">
          <button className="btn-secondary flex items-center gap-2" data-id="element-729">
            <Download size={18} data-id="element-730" />
            Current Wine List
          </button>
        </div>
      </section>

      {/* Outlets Grid */}
      <section className="py-12 px-4 max-w-7xl mx-auto mb-24" data-id="element-731">
        <div className="space-y-16" data-id="element-732">
          {outlets.map((outlet, index) => <motion.div key={outlet.id} className={`flex flex-col ${index % 2 !== 0 ? 'md:flex-row-reverse' : 'md:flex-row'} gap-12 items-center`} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.8
        }} data-id="element-733">
              <div className="w-full md:w-1/2" data-id="element-734">
                <div className="aspect-[4/3] overflow-hidden rounded-sm relative group" data-id="element-735">
                  <img src={outlet.image} alt={outlet.name} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" data-id="element-736" />
                </div>
              </div>
              <div className="w-full md:w-1/2 space-y-6" data-id="element-737">
                <span className="eyebrow" data-id="element-738">{outlet.type}</span>
                <h2 className="text-4xl" data-id="element-739">{outlet.name}</h2>
                <p className="text-club-ink/70 leading-relaxed text-lg" data-id="element-740">
                  {outlet.desc}
                </p>

                <div className="bg-white p-6 border border-club-border rounded-sm space-y-4 mt-6" data-id="element-741">
                  <div className="flex items-start gap-3" data-id="element-742">
                    <Clock size={20} className="text-club-gold shrink-0 mt-0.5" data-id="element-743" />
                    <div data-id="element-744">
                      <h4 className="font-medium text-club-ink text-sm uppercase tracking-wider mb-1" data-id="element-745">
                        Hours of Operation
                      </h4>
                      <p className="text-club-ink/70 text-sm" data-id="element-746">
                        {outlet.timings}
                      </p>
                    </div>
                  </div>
                  <div className="flex items-start gap-3" data-id="element-747">
                    <Info size={20} className="text-club-gold shrink-0 mt-0.5" data-id="element-748" />
                    <div data-id="element-749">
                      <h4 className="font-medium text-club-ink text-sm uppercase tracking-wider mb-1" data-id="element-750">
                        Dress Code
                      </h4>
                      <p className="text-club-ink/70 text-sm" data-id="element-751">
                        {outlet.dressCode}
                      </p>
                    </div>
                  </div>
                </div>

                <div className="pt-4 flex gap-4" data-id="element-752">
                  <Link to={`/dining/${outlet.id}`} className="btn-primary" data-id="element-753">
                    View Menu & Details
                  </Link>
                  <Link to={`/dining/${outlet.id}`} className="btn-secondary" data-id="element-754">
                    Book a Table
                  </Link>
                </div>
              </div>
            </motion.div>)}
        </div>
      </section>
    </div>;
}